<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div class="form-header">
    <h2 class="form-header__title">
      {{ 'loginPageComponent.loginFormComponent.formTitle' | translate }}
    </h2>
    <img src="assets/icons/waving-hand.svg" alt="waving hand emoji" />
  </div>
  @if (showAttemptsWarning()) {
    <span class="attempts-warning error-message">
      {{ attemptsWarningMessage() | translate }}
    </span>
  }
  <div class="form-input-container">
    <div
      class="form-group"
      [ngClass]="{
        'has-error':
          loginForm.get('email')?.touched && loginForm.get('email')?.errors?.['required'],
      }"
    >
      <label class="form-md form-input-container__label" for="email" appRequiredIndicator>
        {{ 'loginPageComponent.loginFormComponent.email.label' | translate }}
      </label>
      <input
        id="email"
        class="form-input"
        type="email"
        formControlName="email"
        placeholder="Example@mail.com"
      />
      @if (loginForm.get('email')?.touched && loginForm.get('email')?.errors?.['required']) {
        <div class="form-err error-message">
          {{ 'loginPageComponent.loginFormComponent.email.requiredEmailErr' | translate }}
        </div>
      }
    </div>
    <div
      class="form-group"
      [ngClass]="{
        'has-error':
          loginForm.get('password')?.touched && loginForm.get('password')?.errors?.['required'],
      }"
    >
      <label class="form-md form-input-container__label" for="password" appRequiredIndicator>
        {{ 'loginPageComponent.loginFormComponent.password.label' | translate }}
      </label>
      <div class="password-container">
        <input
          id="password"
          [type]="isPasswordVisible ? inputType.TEXT : inputType.PASSWORD"
          class="form-input"
          formControlName="password"
          [attr.placeholder]="
            'loginPageComponent.loginFormComponent.password.placeholder' | translate
          "
        />
        <div
          role="button"
          tabindex="0"
          class="icon-wrapper"
          (click)="togglePasswordVisibility()"
          (keydown.enter)="togglePasswordVisibility()"
        >
          <app-icon
            [icon]="isPasswordVisible ? iconName.PASSWORD_EYE : iconName.PASSWORD_EYE_HIDE"
          />
        </div>
      </div>
      @if (loginForm.get('password')?.touched && loginForm.get('password')?.errors?.['required']) {
        <div class="form-err error-message">
          {{ 'loginPageComponent.loginFormComponent.password.requiredPasswordErr' | translate }}
        </div>
      }
    </div>
    <div class="form-options">
      <div class="form-group checkbox-group">
        <mat-checkbox formControlName="rememberMe" color="primary">
          {{ 'loginPageComponent.loginFormComponent.rememberMe' | translate }}
        </mat-checkbox>
      </div>
      <p class="form-text">
        <a class="form-password-restore" [routerLink]="appRoutes.FORGOT_PASSWORD">
          {{ 'loginPageComponent.loginFormComponent.forgotPassword' | translate }}
        </a>
      </p>
    </div>
  </div>
  <button class="form-md btn-primary login-btn" type="submit">
    {{ 'loginPageComponent.loginFormComponent.signInButton' | translate }}
  </button>
  <div class="divider">
    <span>{{ 'signUpPage.signUpForm.or' | translate }}</span>
  </div>
  <app-social-login />
  <p class="form-text form-signup">
    {{ 'loginPageComponent.loginFormComponent.signUpCheck' | translate }}
    <a [routerLink]="appRoutes.SIGN_UP">
      {{ 'loginPageComponent.loginFormComponent.signUpLink' | translate }}
    </a>
  </p>
</form>
